import styled, { css } from 'styled-components/macro'
import { mq } from 'styles/mq'
import { StyledNav } from '../nav/styled'

export const StyledSection = styled.section<{
  $fullHeight?: boolean
  $isIntro?: boolean
}>`
  --vertical-spacing: 3rem;

  position: relative;
  margin: 0 0 0 var(--nav-margin);
  padding: var(--vertical-spacing) 0 var(--vertical-spacing) var(--nav-width);
  scroll-margin-block-start: var(--header-height);

  ${mq.medium} {
    --vertical-spacing: 5rem;
  }

  ${props =>
    props.$fullHeight &&
    css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-height: calc(100vh - var(--header-height));
    `}

  p {
    max-width: 44em;
  }

  h3 {
    margin: 2em 0 0;
  }

  ${props =>
    props.$isIntro &&
    css`
      padding-bottom: 0;

      ${mq.smallOnly} {
        order: -1;
      }
    `}

  ${mq.smallOnly} {
    ${StyledNav} + & {
      order: -1;
    }
  }
`

export const MobileHeading = styled.h2`
  --number-width: 1.5em;

  font: inherit;
  padding-left: var(--number-width);

  ${StyledSection}:not([data-menu-hidden='true']) & {
    counter-increment: section-counter;

    &::before {
      content: counter(section-counter) '. ';
      display: inline-block;
      width: var(--number-width);
      margin-left: calc(-1 * var(--number-width));
    }
  }

  ${mq.medium} {
    display: none;
  }
`
